import { useBaseViewModel } from '@/common';
import { BusinessUnitEntity } from '@/domains/business-unit/entities';
import { FindBusinessUnitByUseCase } from '@/domains/business-unit/usecases';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { BusinessUnitHttpRepository } from '../adapters/repositories/business-unit.http.repository';

export default function GetDetailBusinessUnit() {
  const getDetailBusinessUnit = new FindBusinessUnitByUseCase(new BusinessUnitHttpRepository());
  const [currentQueryParameters] = useSearchParams();
  const getId = currentQueryParameters.get('id');

  const {
    loading: loadingBusinessUnit,
    error: errorBusinessUnit,
    catchAction,
  } = useBaseViewModel();
  const [detailBusinessUnit, setDetailBusinessUnit] = useState<{
    data: BusinessUnitEntity;
  }>({
    data: {
      id: '',
      name: '',
      status: 'ACTIVE',
      parentId: '',
      businessDomainId: '',
      childrenIds: [],
      categoryIds: [],
      offeringProductGroupIds: [],
    },
  });

  const actionGetDetail = () => {
    if (getId) {
      catchAction(async () => {
        const dataDetail = await getDetailBusinessUnit.find(getId);
        setDetailBusinessUnit({ data: dataDetail });
      });
    }
  };

  return {
    loadingBusinessUnit,
    errorBusinessUnit,
    detailBusinessUnit,
    actionGetDetail,
  };
}
